import withInfiniteOptions from "@/components_v2/FormFields/Dropdown/hocs/withInfiniteOptions";
import withCustomChoice from "@/components_v2/FormFields/Dropdown/hocs/withCustomChoice";
import BaseDropdown from "@/components_v2/FormFields/Dropdown/BaseDropdown";

const InfiniteScrollCustomChoiceDropdown = withInfiniteOptions(
  withCustomChoice(BaseDropdown),
);

export default InfiniteScrollCustomChoiceDropdown;
